import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import MaterialTooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import primary from '@material-ui/core/colors/yellow';
import secondary from '@material-ui/core/colors/pink';

import tooltips from './Types';
import TooltipContent from './TooltipContent';

function arrowGenerator(color) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${color} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${color} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.9em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: `transparent ${color} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.9em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: `transparent transparent transparent ${color}`,
      },
    },
  };
}


const styles = theme => ({
  tooltip: {
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 18,
    padding: 0,
    opacity: 1,
  },
  primaryColor: {
    backgroundColor: theme.palette.primary.light,
  },
  secondaryColor: {
    backgroundColor: theme.palette.primary.dark,
  },
  arrowPopperPrimary: arrowGenerator(primary[100]),
  arrowPopperSecondary: arrowGenerator(secondary[100]),
  arrow: {
    position: 'absolute',
    fontSize: 17,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
});

const getTooltipContent = (classes, type, tooltip, ref) => {
  return (
    <React.Fragment>
      <TooltipContent title={type} type={type} tooltip={tooltip} />
      <span className={classes.arrow} ref={ref} />
    </React.Fragment>
  );
};


// const getChild = (children, showTooltip, type) => {
//   if (showTooltip && type === "invoice-select-job") {
//     console.log("select job tooltip")
//
//     return (
//       <div
//         style={{
//           position: "fixed",
//           top: 500,
//           left: 500,
//           zIndex: 9999
//         }}
//       >
//         {children}
//       </div>
//     );
//   } else {
//     return {children}
//   }
// }

const getArrowPopperStyles = (classes, tooltip) => {
  if (tooltip.type === "primary") {
    return classes.arrowPopperPrimary;
  } else if (tooltip.type === "secondary") {
    return classes.arrowPopperSecondary;
  }
}

class Tooltip extends Component {
  state = {
    arrowRef: null,
  };

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    });
  };

  render() {
    const {
      classes,
      children,
      placement,
      type,
      help
    } = this.props;
    const { arrowRef } = this.state;
    const currentMission = help.currentMission;
    const currentStepIndex = currentMission.currentStep;
    const currentStep = currentMission.steps[currentStepIndex];
    const tooltip = tooltips.get(type);
    let showTooltip;

    if (help.showHelp) {
      showTooltip = true;
    } else if (!currentStep) {
      showTooltip = false;
    } else if((currentStep.primaryType === type) || (currentStep.secondaryType === type)) {
      showTooltip = true;
    } else {
      showTooltip = false;
    }

    // const test = $( `#${type}` );
    // const offset = test.offset();
    // console.log("TEST:", test.offset());

    // if (test && offset) {
    //   test.css({
    //     position: "fixed",
    //     zIndex: 9999,
    //     top: offset.top, left: offset.left
    //   })
    // }
    if (showTooltip && type) {
      return(
        <MaterialTooltip
          open={showTooltip}
          placement={placement}
          title={getTooltipContent(classes, type, tooltip, this.handleArrowRef)}
          classes={{ tooltip: classes.tooltip, popper: getArrowPopperStyles(classes, tooltip) }}
          PopperProps={{
            popperOptions: {
              modifiers: {
                arrow: {
                  enabled: Boolean(arrowRef),
                  element: arrowRef,
                },
              },
            },
          }}
        >
          {children}
        </MaterialTooltip>
      );
    } else {
      return children;
    }
  }
}

//const Tooltip = (props) => {
  //console.log("CHILREN", children);
  // const test = $( "#test-id1" );
  // console.log("TEST:", test);
  // test.offset({left: 500, top: 500});
  // if (showTooltip && type) {
  //   return(
  //     <MaterialTooltip
  //       open={showTooltip}
  //       placement={placement}
  //       classes={{ tooltip: classes.tooltip }}
  //       title={getTooltipContent(type)}
  //     >
  //       <OverlayElevator type={type}>
  //           {children}
  //       </OverlayElevator>
  //     </MaterialTooltip>
  //   );
  // } else {
  //   return children;
  // }
//}


const mapStateToProps = (state) => ({
  help: state.help,
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(Tooltip);

// export {
//   TooltipTypes,
// };



// WEBPACK FOOTER //
// ./src/components/admin/Help/Tooltips/Tooltip.jsx